import { ElementRef, Injector, Component, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../base.component';

const LOGOS_INTERVAL = 1500;
const LABELS_INTERVAL = 1800;
const REPORT_INTERVAL = 10000;
@Component({
	selector: 'preloader',
	template: `
		<div class="container {{ attributes.abntestClass }}">
			<h1>{{ attributes.title }}</h1>
			<h2 class="sub" [innerHtml]="attributes.subtitle"></h2>
			<p id="subtitle2" class="sub" [innerHtml]="attributes.subtitle2"></p>

			<img *ngIf="attributes.proglogo" class="prog-logo" src="{{ attributes.proglogo }}" width="100" />
			<img
				class="hidden-test-pixle"
				src="{{ attributes.testPixle }}"
				style="visibility:hidden"
				alt="{{ attributes.testPixle }}"
			/>
			<div class="image-spinner">
				<img ng-animate-swap="currentImageIndex" src="{{ attributes.logosArray[currentImageIndex] }}" />
				<div class="loader-spinner"></div>
			</div>

			<h3 ng-animate-swap="currentLabelIndex">
				{{ attributes.spinnerLabels[currentLabelIndex] }}
			</h3>
		</div>
	`,
	styleUrls: ['./preloader.component.scss'],
})
export class PreloaderComponent extends BaseComponent implements OnInit, OnDestroy {
	currentImageIndex: any;
	currentLabelIndex: any;
	attributes: any;
	logosInterval: any;
	labelsInterval: any;
	ajaxInfoInterval: any;
	timer: any;
	counter = 1;

	constructor(injector: Injector, private el: ElementRef) {
		super(injector);
	}

	ngOnInit() {
		const {
			backgroundImage,
			logosArray,
			ajaxInfoInterval,
			title,
			subtitle,
			subtitle2,
			spinnerLabels,
			proglogo,
			testPixle,
			abntestClass,
		} = this.layoutService.staticLayout.getValue().data.ui.page.attributes;

		this.currentImageIndex = 0;
		this.currentLabelIndex = 0;
		this.attributes = {
			title,
			subtitle,
			subtitle2,
			logosArray,
			spinnerLabels,
			proglogo,
			testPixle,
			abntestClass,
		};

		this.layoutService.staticLayout.subscribe((data) => {
			if (data && data.data.metadata.page.stage == 'YourRates') {
				this.ngOnDestroy();
			}
		});

		// set bg image
		this.el.nativeElement.style.backgroundImage = `url(${backgroundImage})`;

		// set interval for rotated image array
		this.logosInterval = setInterval(() => {
			this.currentImageIndex = (this.currentImageIndex + 1) % logosArray.length;
		}, LOGOS_INTERVAL);

		// set interval for rotated image array
		this.labelsInterval = setInterval(() => {
			this.currentLabelIndex = (this.currentLabelIndex + 1) % spinnerLabels.length;
		}, LABELS_INTERVAL);

		// set interval for checking if next page is ready
		// IMPORTANT: in case server is delayed when rates recieved, ajaxInfoInterval will continue stacking requests into queue in action-api.service
		//, which will pass to rates page. Redesign of ajax logic is required to avoid this.
		this.ajaxInfoInterval = setInterval(() => {
			this.actionService.ajaxAction(this.storeService.getPreloaderAjaxInfo(), 'page');
			//   Store.dispatch(remoteAction($element, Store.getState().ui.page.ajaxInfo.action));
		}, ajaxInfoInterval);

		// Scroll to top
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 100);

		this.timer = setInterval(() => {
			this.counter++;
		}, REPORT_INTERVAL);
	}

	ngOnDestroy() {
		clearInterval(this.timer);
		clearInterval(this.logosInterval);
		clearInterval(this.labelsInterval);
		clearInterval(this.ajaxInfoInterval);
	}
}
